// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"df4b9a69","453":"d9a40843"}[chunkId] + ".chunk.js";
};